<template>
  <div :class="`field-list`">
    <language-list
      v-if="isLang === true"
      v-model="langCurrent"
      :name="`${item.id}${name ? name : ''}`"
    />

    <div :class="`${simple ? '' : 'field-list-content'}`">
      <div class="row">
        <template v-for="field in fields">
          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-if="
              field.ishide !== true &&
              field.type === 'field' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <fg-input
              :info="field.info"
              :type="field.textType"
              :labelLang="field.labelLang"
              :label="field.label"
              v-model="item[field.key]"
              :readonly="field.readonly"
              step="1"
            ></fg-input>
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-if="
              field.ishide !== true &&
              field.type === 'mask' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <fg-input
              type="text"
              :value="field.default"
              :placeholder="field.placeholder"
              :label="field.label"
              :labelKey="field.labelKey"
              v-mask="field.mask"
              :labelLang="field.labelLang"
              v-model="item[field.key]"
            />
          </div>
          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-if="field.type === 'alif-passport-issue'"
            :key="field.key"
          >
            <PASSPORT v-model="item[field.key]" :partner="field['partner']" />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-if="field.type === 'alif-region'"
            :key="field.key"
          >
            <REGIONS v-model="item[field.key]" :partner="field['partner']" />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-if="
              field.ishide !== true &&
              field.type === 'tag' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <label
              >{{ field.labelKey | setText(field.label) }}
              <info v-if="field.info" :id="field.info"
            /></label>

            <tags v-model="item[field.key]" />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'img' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <img-upload
              :name="field.key"
              @change="change"
              v-model="item[field.key]"
              :title="field.label"
            />
          </div>
          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'img_base64' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <img-upload-base64 v-model="item[field.key]" :title="field.label" />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'imgs' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <images
              :url="field.image_key"
              v-model="item[field.key]"
              :title="field.label"
              :result="item[field.resultKey]"
              :link="field.link"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'zip' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <zip-upload
              v-model="item[field.key]"
              :title="field.label"
              :result="item[field.resultKey]"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'select' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <selector
              :disabled="
                field.readonly || (field.needKey && !item[field.needKey])
              "
              :fieldKey="field.key"
              v-model="item[field.key]"
              :title="field.label"
              :titleKey="field.labelKey"
              :prefix="field.prefix"
              :modal="field.modal"
              :url="field.url"
              :params="field.params"
              :selectKey="field.selectKey"
              @input="conditional"
            />
          </div>
          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'select-full' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <selector
              :disabled="
                field.readonly || (field.needKey && !item[field.needKey])
              "
              type="list-item-full"
              :fieldKey="field.key"
              v-model="item[field.key]"
              :title="field.label"
              :titleKey="field.labelKey"
              :prefix="field.prefix"
              :modal="field.modal"
              :url="field.url"
              :params="field.params"
              :selectKey="field.selectKey"
              @input="conditional"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'selects' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <selectors
              :url="field.url"
              :fieldKey="field.key"
              :disabled="field.readonly"
              :selectKey="field.selectKey"
              v-model="item[field.key]"
              :title="field.label"
              :titleKey="field.labelKey"
              :modal="field.modal"
              :prefix="field.prefix"
              :params="field.params"
              @input="conditional"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'datetime' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <label
              >{{ field.labelKey | setText(field.label) }}
              <info v-if="field.info" :id="field.info"
            /></label>
            <datetime
              class="from-control"
              type="datetime"
              v-model="item[field.key]"
              format="dd/MM/yyyy HH:mm:ss"
            ></datetime>
          </div>
          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'date' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <label
              >{{ field.labelKey | setText(field.label) }}
              <info v-if="field.info" :id="field.info"
            /></label>
            <datetime
              class="from-control"
              type="date"
              v-model="item[field.key]"
              format="dd/MM/yyyy"
            ></datetime>
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'checkbox' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <checkbox class="mb-3" v-model="item[field.key]" color="#2c75ff">{{
              field.labelKey | setText(field.label)
            }}</checkbox>
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-else-if="field.type === 'map'"
            :key="field.key"
          >
            <label
              >{{ field.labelKey | setText(field.label) }}
              <info v-if="field.info" :id="field.info"
            /></label>

            <map-set
              :defaultLat="item['lat']"
              :defaultLon="item['lon']"
              v-model="item[field.key]"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'static_radio' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <radio-list
              @input="change"
              :title="field.label"
              :items="field.items"
              :name="field.key"
              v-model="item[field.key]"
              color="#ffc107"
              >{{ field.labelKey | setText(field.label) }}</radio-list
            >
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'object' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <h4>{{ field.labelKey | setText(field.label) }}</h4>
            <sub-field-list
              v-model="item[field.key]"
              :subFields="field.subFields"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'location' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <label>{{ field.labelKey | setText(field.label) }} </label>

            <location
              :city="item.location ? item.location.id : null"
              :region="item.location ? item.location.location_id : null"
              v-model="item[field.key]"
            />
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'textarea' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <div class="form-group">
              <label class="control-label"
                >{{ field.labelKey | setText(field.label) }}
                <span v-if="field.labelLang"> ({{ field.labelLang }})</span>
              </label>
              <textarea class="form-control" v-model="item[field.key]" />
            </div>
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-show="!field.langKey || (field.langKey && langCurrent)"
            v-else-if="
              field.ishide !== true &&
              field.type === 'role' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <div class="form-group">
              <label class="control-label"
                >{{ field.labelKey | setText(field.label) }}
                <info v-if="field.info" :id="field.info"
              /></label>
              <role v-model="item[field.key]" />
            </div>
          </div>

          <div
            :class="field.col ? field.col : 'col-12'"
            v-else-if="
              field.ishide !== true &&
              field.type === 'html' &&
              field.isMultiLang !== true
            "
            :key="field.key"
          >
            <div v-show="!field.langKey || (field.langKey && langCurrent)">
              <label class="control-label"
                >{{ field.labelKey | setText(field.label) }} ({{
                  field.labelLang
                }}) <info v-if="field.info" :id="field.info"
              /></label>

              <quill-editor
                @input="$emit('input', item)"
                v-model="item[field.key]"
                :options="editorOption"
              />
              <br />
            </div>
          </div>
        </template>
      </div>
      <button v-if="withButton" @click="change" class="btn btn-info mw">
        Применить
      </button>
    </div>
  </div>
</template>
<script>
/**Меняю добавление модалку */
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { mapState } from "vuex";
import PASSPORT from "@/components/Partners/alif/REFERENCES/PASSPORT.vue";
import REGIONS from "@/components/Partners/alif/REFERENCES/REGIONS.vue";
export default {
  name: "FieldsList",
  data: () => ({
    langCurrent: null,
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "image", "video"], // toggled buttons
          ["blockquote", "code-block"],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
        ],
      },
    },
  }),
  components: {
    quillEditor,
    PASSPORT,
    REGIONS,
  },
  props: ["item", "fields", "name", "simple", "withButton"],
  computed: {
    //add
    ...mapState(["languages"]),

    //add
    isLang: {
      get() {
        for (let i = 0; i < this.fields.length; i++) {
          if (this.fields[i].isMultiLang) {
            return true;
          }
        }
        return false;
      },
    },
  },
  created() {
    for (let i = 0; i < this.fields.length; i++) {
      if (this.fields[i].type === "hidden") {
        this.item[this.fields[i].key] = this.fields[i].value;
      }
      if (this.fields[i].default && !this.item[this.fields[i].key]) {
        this.item[this.fields[i].key] = this.fields[i].default;
      }
    }
  },
  methods: {
    change() {
      this.$emit("change", true);
    },
    conditional(val, fieldKey = "") {
      for (let i = 0; i < this.fields.length; i++) {
        if (
          this.fields[i] &&
          this.fields[i]["parentPush"] &&
          fieldKey == this.fields[i]["parentPush"]
        ) {
          this.fields.splice(i, 1);
        }
      }
      for (let i = 0; i < this.fields.length; i++) {
        //

        if (
          this.fields[i] &&
          this.fields[i].toParametr &&
          this.fields[i].toParametr.parametr &&
          this.fields[i].toParametr.key
        ) {
          let key = this.fields[i].toParametr.key;
          let parametr = this.fields[i].toParametr.parametr;

          // console.log("1) fieldKey: ", fieldKey);
          // console.log("1) key: ", key);

          if (key && parametr && fieldKey === key) {
            if (fieldKey === key) {
              this.item[this.fields[i].key] = null;
            }
            let value = null;

            if (val && val.id) {
              value = val.id;
            }
            this.fields[i].params[parametr] = value;

            // console.log("2) fieldKey: ", fieldKey);
            // console.log("2) key: ", key);
            // console.log("2) val: ", val);
            // console.log("2) value: ", value);
          }
        }

        if (
          this.fields[i] &&
          this.fields[i]["key"] &&
          this.fields[i]["push"] &&
          this.fields[i]["key"] == fieldKey &&
          val &&
          val["code"] &&
          this.fields[i]["push"][val["code"]]
        ) {
          this.fields.push(this.fields[i]["push"][val["code"]]);
        }

        //
      }

      this.$emit("change", true);
    },
  },
};
</script>

